import React,{useState} from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Padlock, Bin } from "../../../../assets/icons";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import toast from 'react-hot-toast'
import { Button,  } from "../../../../UI";
import Container from "./styles";
import { AdminOrders } from "../../../../store/actions";
import {useDispatch} from 'react-redux';

const AdminDetails = () => {
  const navigate = useNavigate();
  const { state: query } = useLocation();
  const [address2, setAddress2] = useState([])
  const dispatch = useDispatch()
  const OrderId = query?.state;
  
  function OrderManager(e){
     if(address2.length > 0){
      const data = {
        "tracking_number": OrderId?.reference,
        "status": e,
        "notes":address2
    }
      dispatch(AdminOrders(data,"update", navigate))
     }else {
      toast.error("Enter a comment")
    }
  }

  return (
    <Container>
      <header>
        <div className="row-1">
          <NavLink to="/dashboard/orders" exact={true}>
            Orders
          </NavLink>
        </div>
        <div className="row-2">
          <Button
            icon
            arial-label="prev admin"
            onClick={() => {
              navigate(-1);
            }}
          >
            <IoIosArrowBack />
          </Button>
        </div>
      </header>
      <div className="admin--details__container">
        <div className="profile--row">
          <div className="col-1">
            <div className="img--contents">
              <div className="img--container">{OrderId?.email?.charAt(0)}</div>
            </div>
            <div className="profile--content">
              <h3>{OrderId?.email}</h3>
              <p>{OrderId?.id}</p>
              <p>{OrderId?.pick_up_phone_number}</p>
              <p
                className="offline"
                style={
                  OrderId?.status == "canceled"
                    ? {}
                    : OrderId?.status == "pending"
                    ? { backgroundColor: "yellow", color: "#000" }
                    : { backgroundColor: "green" }
                }
              >
                {OrderId?.status}
              </p>
            </div>
          </div>
          <div className="col-2">
            <Button icon onClick={() =>{OrderManager("pending")}}>
              <Padlock />
              Pending
            </Button>
            <Button className="btn--deactivate" onClick={() =>{OrderManager("fulfilled")}}>Successful Order</Button>
            <Button icon className="btn--delete" onClick={() =>{OrderManager("canceled")}}>
              <Bin />
              Cancel Order
            </Button>
          </div>
        </div>
        <div style={{display:"flex", position:"relative"}}>
        <div className="activities--container">
          <h3>Order Details</h3>
          <div className="activity--lists">
            <div>Pickup address: {OrderId?.pick_up_address}</div>
            <div>Pickup city: {OrderId?.pick_up_city}</div>
            <div>Pickup full name: {OrderId?.pick_up_full_name}</div>
            <div>Pickup phone number: {OrderId?.pick_up_phone_number}</div>
            <div>Recipient full name:{OrderId?.recipient_full_name}</div>
            <div>Recipient phone number: {OrderId?.recipient_phone_number}</div>
            <div>Reference: {OrderId?.reference}</div>
            <div>description: {OrderId?.description}</div>
            <div>distance: {OrderId?.distance}</div>
            <div>Drop off address: {OrderId?.drop_off_address}</div>
            <div>Drop off city: {OrderId?.drop_off_city}</div>
          </div>
        </div>
        <div className="activities--container" style={{position:"absolute", right:0}}>
        <h3>Comment</h3>
         <textarea
          placeholder="write your comment here..."
          onChange={(e)=>{
            setAddress2(e.target.value)
          }}
          style={{width:300,height:200, marginTop:20,border:"none",backgroundColor:"#1b203a", padding:10}}/>
        </div>
        </div>
      </div>
    </Container>
  );
};

export default AdminDetails;
